<template>
    <div class="highlights-slide" v-if="$store.state.highlights">
        <h2 class="highlights-title" v-html="$store.state.highlights.title"></h2>

        <swiper :options="options" ref="highlights">
            <swiper-slide v-for="(item, index) in $store.state.highlights.items" :key="index">
                <Link class="item" :post_link="item.link">
                    <figure>
                        <img :src="item.image.sizes.large" :alt="item.image.alt">
                    </figure>
                    <div class="info">
                        <h3 v-html="item.title"></h3>
                    </div>
                </Link>
            </swiper-slide>
        </swiper>
    </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import Link from '@/components/ui/Link.vue';

export default {
    name: 'Highlights',

    data () {
        return {
            options: {
                slidesPerView: 1.5,
                spaceBetween: 0,
                // mousewheel: true,

                navigation: {
                    nextEl: '.js-next',
                    prevEl: '.js-prev',
                },

                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },

                breakpoints: {
                    798: {
                        slidesPerView: 3,
                    }
                }
            },
        }
    },
    components: {
        Link,
        Swiper,
        SwiperSlide,
    },
}
</script>
<style lang="scss">
    .highlights-slide {
        padding: var(--padding-50) var(--padding-50) var(--padding);
        position: relative;
        overflow: hidden;

        .highlights-title {
            padding: var(--padding-25) var(--padding-50);
            line-height: 1.1;
            font-size: var(--title-size);
        }

        .swiper-container {
            overflow: visible;
        }

        .swiper-slide {
            padding: var(--padding-50);
            box-sizing: border-box;
            transform: translateZ(0);
        }

        .item {
            display: block;

            figure {
                display: block;
                position: relative;

                &::before {
                    content: '';
                    padding: 0 0 133%;
                    display: block;
                }
            }

            img {
                width: 100%;
                height: 100%;
                position: absolute;
                object-fit: cover;
                top: 0;
                left: 0;
            }
            
            .info {
                padding: var(--padding-25) 0 0;
                font-size: var(--large-size);
            }
        }
    }

    @media only screen and (max-width: 767px) {
        .highlights-slide {
            padding: var(--padding) var(--padding-50);
        }

    }
</style>
